module.exports = __webpack_public_path__ + "static/img/default-avatar.7750d63e.png";